import WoCuttingPdfButton from "components/Pdfs/WoCuttingPdf/WoCuttingPdfButton";
import WoStatusOptions, { WoStatusReadOnly } from "components/WoStatusOptions";
import { approvalBadgeTone } from "utils/approvalStage";
import WOPdfButton from "components/Pdfs/WOPdf/WOPdfButton";
import ImgWithSignedUrl from "components/SignedUrl/ImgWithSignedUrl";
import Spinner from "components/Spinner";
import useWorkOrder from "features/Contexts/WorkOrderContext";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import ReactQuill from "react-quill";
import { useDispatch } from "react-redux";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import QuickViewContact from "./QuickViewContact";
import QuickViewProducts from "./QuickViewProducts";
import QuickViewProductSizes from "./QuickViewProductSize";
import QuickViewProductSummary from "./QuickViewProductSummary";
import SendWoApproval from "pages/Sales/WorkOrders/WorkOrderDetails/LotApproval/SendWoApproval";
import SendWoFeedback from "pages/Sales/WorkOrders/WorkOrderDetails/LotApproval/SendWoFeedback";

export default function QuickViewWorkOrder({
  btnText = "Quick View",
  btnClasses,
  hideCustomerViewBtn,
  filterBy,
  // selectedId,
  workOrdersList,
  refreshFunc,
  active,
  show,
  setShow,
  updateSearchParams,
  // Invoice toggle is editable by default so every QuickView gets it (the
  // Work Orders module's included). Call sites that need it read-only still
  // opt in explicitly — Job Board passes its own flag.
  disabledInvoice = false,
  skipRefreshOnClose = false,
}) {
  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
      ["clean"],
    ],
  };
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  /*   All States
   ********************************************* */

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [currentId, setCurrentId] = useState(null);
  const [selected, setSelected] = useState(null);
  const [allWOData, setAllWOData] = useState([]);

  const [productsList, setProductsList] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isViewReady, setIsViewReady] = useState(false);

  const [allProducts, setAllProducts] = useState(null);

  const [isAllReady, setIsAllReady] = useState(false);

  const [productTypesList, setProductTypesList] = useState([]);
  const [selectedProductType, setSelectedProductType] = useState(null);

  const [productTypeSummary, setProductTypeSummary] = useState([]);
  const [productSummaryModal, setProductSummaryModal] = useState(false);

  const [invoiceReady, setInvoiceReady] = useState(false);
  const [printed, setPrinted] = useState(false);

  const [showContactModal, setShowContactModal] = useState(false);
  const [pendingProductTypeUpdates, setPendingProductTypeUpdates] = useState(
    {},
  );

  /*   All Functions
   ********************************************* */
  const loadingOn = () => {
    setLoading(true);
  };

  const loadingOff = () => {
    setLoading(false);
  };

  const previousWorkOrder = () => {
    let selectedWoId = searchParams.get("selected-work-order");

    const currentIndex = allWOData.findIndex(
      (wo) => wo.woId === parseInt(selectedWoId),
    );
    if (currentIndex > 0) {
      setIsViewReady(false);
      setSelectedProduct(null);
      setSelectedProductType(null);
      setProductsList(null);
      setAllProducts(null);

      // update search params with previous work order id
      const previousWO = allWOData[currentIndex - 1];

      updateSearchParams("selected-work-order", previousWO.woId);
    }
  };

  const nextWorkOrder = () => {
    // setSelectedProductType(null);
    let selectedWoId = searchParams.get("selected-work-order");
    const currentIndex = allWOData.findIndex(
      (wo) => wo.woId === parseInt(selectedWoId),
    );

    if (currentIndex < allWOData.length - 1) {
      setIsViewReady(false);
      setSelectedProduct(null);
      setSelectedProductType(null);
      setProductsList(null);
      setAllProducts(null);
      // Get the next work order
      const nextWO = allWOData[currentIndex + 1];

      updateSearchParams("selected-work-order", nextWO.woId);
    }
  };

  /**
   * Updates Status of Work Order.
   * Does not updates the work order list so going back and forth will not update the list.
   */
  const handleWOStatusChange = async (e) => {
    let WOStatus = e.target.value;

    let newAllWOData = allWOData.map((item) => {
      if (item.woId === selected.woId) {
        return { ...item, WOStatus };
      } else {
        return item;
      }
    });
    setAllWOData(newAllWOData);
    loadingOn(true);
    try {
      const { data } = await API.patch(
        "/work-orders",
        {
          data: { WOStatus: WOStatus },
          id: selected.id,
        },
        { headers: authHeader() },
      );

      if (data.message.type === "success") {
        loadingOff();
        return;
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
      loadingOff();
    }
  };

  const { clearWorkOrderData, setCustomerData } = useWorkOrder();

  const handleViewCustomer = () => {
    setCustomerData({ id: selected?.customerId });
    clearWorkOrderData();

    navigate(`/customer/details/${selected?.customer?.customerId}`);
  };

  const getAllProductTypes = async () => {
    try {
      const { data } = await API.get("/productTypes", {
        headers: authHeader(),
      });

      // Sort data by sortId
      data.sort((a, b) => {
        return a.sortId - b.sortId;
      });
      // Set the product types list in state
      setProductTypesList(data);
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  const getAllProducts = async (id) => {
    try {
      setIsViewReady(false);
      loadingOn();
      const { data } = await API.get("/wo-products/" + id, {
        headers: authHeader(),
      });
      if (data?.success) {
        setAllProducts(data?.data);
        loadingOff();
        return data?.data || [];
      }

      loadingOff();
      return [];
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
      return [];
    }
  };

  const handleProductTypeFilter = (item) => {
    if (!allProducts || allProducts.length === 0) {
      setIsViewReady(false);
      setSelectedProductType(item);
      setProductsList([]);
      setSelectedProduct(null);
      return;
    }

    setSelectedProductType(item);
    if (item === null) {
      setProductsList(allProducts);
      setSelectedProduct((prev) => {
        const match = prev && allProducts.find((p) => p.id === prev.id);
        return match || allProducts[0];
      });
      setIsViewReady(true);
      return;
    }
    let filteredList = allProducts.filter((product) => {
      return product?.productTypeId === item.productTypeId;
    });

    if (filteredList.length === 0) {
      setProductsList(allProducts);
      setSelectedProduct((prev) => {
        const match = prev && allProducts.find((p) => p.id === prev.id);
        return match || allProducts[0];
      });
      setSelectedProductType(null);
      setIsViewReady(true);
      return;
    }

    setProductsList(filteredList);
    setSelectedProduct((prev) => {
      const match = prev && filteredList.find((p) => p.id === prev.id);
      return match || filteredList[0];
    });
    setIsViewReady(true);
    return filteredList;
  };

  // Printed is a WORK ORDER flag (WorkOrders.printed), like Invoiced -- not a
  // per-product one like Ready. Same optimistic local update so the list behind
  // the modal reflects it without a refetch.
  // Generating either PDF from QuickView means the order has been printed --
  // staff print straight from the preview, so waiting for a Download click
  // would miss most prints. Fires again on download; the early return keeps
  // that from sending a pointless second PATCH.
  const markPrintedFromPdf = () => {
    if (printed) return;
    setPrinted(true);
    UpdatePrinted({ printed: true });
  };

  const UpdatePrinted = async ({ printed }) => {
    try {
      loadingOn(true);
      const { data } = await API.patch(
        "/wo-products/printed-status",
        { WOId: selected?.id, printed },
        { headers: authHeader() },
      );
      if (data?.success) {
        setAllWOData((prev) => {
          const updated = [...prev];
          updated.forEach((wo) => {
            if (wo.id === selected?.id) wo.printed = printed;
          });
          return updated;
        });
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err?.response?.data?.message || err.message,
          type: "error",
        }),
      );
    } finally {
      loadingOn(false);
    }
  };

  const UpdateInvoiceReady = async ({ invoiceReady }) => {
    try {
      loadingOn(true);

      const { data } = await API.patch(
        "/wo-products/invoice-ready-status",
        {
          WOId: selected?.id,
          invoiceReady: invoiceReady,
        },
        { headers: authHeader() },
      );

      if (data?.success) {
        // Filter out current workorder from allWOData and update it with new data

        setAllWOData((prev) => {
          let updatedWOData = [...prev];
          updatedWOData.forEach((wo) => {
            if (wo.id === selected?.id) {
              wo.invoiceReady = invoiceReady;
            }
          });
          return updatedWOData;
        });

        dispatch(
          setNotification({
            message: data.message,
            type: "success",
          }),
        );
      }

      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  /**
   * @param(selectedType) - filterBy
   * Counts the number products of selected type and total quantity of that type.
   * @returns(Number,total quantity) - Number of products of selected type.
   */
  const countProducts = (selectedType) => {
    if (!selectedType) {
      const summary = allProducts?.reduce(
        (acc, item) => {
          acc.totalQuantity += item.totalQuantity;
          acc.count += 1;
          return acc;
        },
        { totalQuantity: 0, count: 0 },
      );

      return summary;
    }

    const summary = allProducts?.reduce(
      (acc, item) => {
        if (item?.productTypeId === selectedType?.productTypeId) {
          acc.totalQuantity += item.totalQuantity;
          acc.count += 1;
        }
        return acc;
      },
      { totalQuantity: 0, count: 0 },
    );

    return summary;
  };

  // get total quantity of all products
  const getTotalQuantity = () => {
    return allProducts?.reduce((acc, item) => {
      acc += item.totalQuantity;
      return acc;
    }, 0);
  };

  const getReadyStatusForCurrentProductType = () => {
    // set ready to true only if all products in the current list (selected
    // product type, or all products when no type is selected) are ready
    setIsAllReady(
      !!productsList?.length &&
        productsList.every((product) => product.isReady),
    );
  };

  const handleProductSummary = (item, productsToUse) => {
    const list =
      (productsToUse || allProducts)?.filter(
        (product) => product?.productTypeId === item?.productTypeId,
      ) || [];

    setProductTypeSummary(list);
    setProductSummaryModal(true);
  };

  const handleAllProductSummary = () => {
    setProductTypeSummary(allProducts || []);
    setProductSummaryModal(true);
  };

  const getPendingTypeUpdatesCount = () => {
    return Object.keys(pendingProductTypeUpdates || {}).length;
  };

  const applyPendingTypeUpdates = async () => {
    const pendingEntries = Object.entries(pendingProductTypeUpdates || {});

    if (pendingEntries.length === 0 || !selected?.id) {
      return;
    }

    try {
      const preservedSelectedProductId = selectedProduct?.id;
      const selectedProductPendingUpdate = preservedSelectedProductId
        ? pendingProductTypeUpdates?.[preservedSelectedProductId]
        : null;

      const refreshedProducts = await getAllProducts(selected.id);
      const refreshedSelectedProduct = preservedSelectedProductId
        ? refreshedProducts.find(
            (product) => product.id === preservedSelectedProductId,
          )
        : null;

      if (refreshedSelectedProduct) {
        const nextSelectedTypeId =
          selectedProductPendingUpdate?.productTypeId ||
          refreshedSelectedProduct?.productTypeId;

        const nextSelectedProductType = productTypesList.find(
          (item) => item?.productTypeId === nextSelectedTypeId,
        );

        if (selectedProductPendingUpdate && nextSelectedProductType) {
          const nextProductsList = refreshedProducts.filter(
            (product) => product?.productTypeId === nextSelectedTypeId,
          );

          setSelectedProductType(nextSelectedProductType);
          setProductsList(nextProductsList);
          setSelectedProduct(
            nextProductsList.find(
              (product) => product.id === refreshedSelectedProduct.id,
            ) || refreshedSelectedProduct,
          );
        } else {
          setSelectedProduct(refreshedSelectedProduct);
        }
      }

      setPendingProductTypeUpdates({});

      dispatch(
        setNotification({
          message: `Refreshed ${pendingEntries.length} product type update${
            pendingEntries.length > 1 ? "s" : ""
          } in view.`,
          type: "success",
        }),
      );
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  // ONE decision, taken in utils/approvalStage.js from the stored stage;
  // the wording and classes below stay local because the screens differ.
  // This used to re-derive the stage from the approval cards right here --
  // a second definition, free to disagree with the Approvals tab and with
  // the other copy of this same function.
  const getApprovalStatus = (item) => {
    switch (approvalBadgeTone(item)) {
      case "rejected":
        return { text: "Rejected", className: "bg-danger text-white" };
      case "approved":
        return { text: "Approved", className: "bg-success text-white" };
      case "partial":
        return {
          text: "Partially",
          className: "border border-success border-3 text-black",
          style: { backgroundColor: "#ffff00" },
        };
      case "not_sent":
        return { text: "Not sent", className: "bg-secondary text-white" };
      default:
        return { text: "Pending", className: "bg-info text-white" };
    }
  };

  const UpdateProductReady = async ({ ready }) => {
    try {
      loadingOn(true);

      const { data } = await API.patch(
        "/wo-products/ready-status",
        {
          WOId: selected?.id,
          productTypeId: selectedProductType?.productTypeId,
          isReady: ready,
        },
        { headers: authHeader() },
      );

      if (data?.success) {
        // update all products where productType matches
        setAllProducts((prev) => {
          let updatedProducts = [...prev];
          updatedProducts.forEach((product) => {
            if (product?.productTypeId === selectedProductType?.productTypeId) {
              product.isReady = ready;
            }
          });
          return updatedProducts;
        });

        // // Get current index of workOrder in allWOData
        // let currentWOIndex = allWOData?.findIndex(
        //   (item) => item.id === selected?.id
        // );
        // // Get current index of product in allWOData

        // let currentProductIndex = allWOData[
        //   currentWOIndex
        // ]?.WOProducts?.findIndex((item) => item.id === selectedProduct.id);
        // // Update the product in allWOData
        // let updatedWOData = JSON.parse(JSON.stringify(allWOData));
        // updatedWOData[currentWOIndex].WOProducts[currentProductIndex] =
        //   updatedProduct;
        // setAllWOData((prev) => updatedWOData);

        dispatch(
          setNotification({
            message: data.message,
            type: "success",
          }),
        );
      }

      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  // First 5 letters of the inside sales person's name, shown in parentheses
  // after the customer name. Renders nothing when the WO has no inside sales
  // person, or when the call site's list payload didn't include the
  // association — not every QuickView is fed from the work orders list.
  const insideSalesShort = (() => {
    const person = selected?.insideSalesPerson;
    if (!person) return "";
    const name = `${person.firstName || ""} ${person.lastName || ""}`.trim();
    return name ? ` (${name.slice(0, 5)})` : "";
  })();

  // reset all data
  const resetData = async () => {
    if (!skipRefreshOnClose && refreshFunc) {
      await refreshFunc(active);
    }

    setCurrentId(null);
    setSelected(null);
    setSelectedProduct(null);
    setIsViewReady(false);
    setSelectedProductType(null);
    setProductsList(null);
    setAllProducts(null);
    setIsAllReady(false);
    setProductTypesList([]);
    setProductTypeSummary([]);
    setPendingProductTypeUpdates({});

    setShow && setShow(false);
    setShowModal(false);
    setSelectedProductType(null);
    // remove selected work order from search params
    updateSearchParams("selected-work-order", null);
  };

  /*   All UseEffects
   ********************************************* */
  // Set Selected Work Order
  useEffect(() => {
    let timeout = setTimeout(() => {
      setLoading(true);
      if (currentId && allWOData) {
        let _selected = allWOData.find((wo) => wo.woId === parseInt(currentId));
        setSelected((prev) => _selected);
      }
      setLoading(false);
    }, 50);
    return () => clearTimeout(timeout);
  }, [allWOData, currentId]);

  // Reset selectedProduct and productsList when selected work order changes
  // useEffect(() => {
  //   // Only run if selected changes and showModal is open
  //   if (selected && showModal) {
  //   }
  // }, [selected, showModal]);

  useEffect(() => {
    let selectedWorkOrderId = searchParams.get("selected-work-order");
    if (selectedWorkOrderId && allWOData && allWOData.length > 0) {
      // Convert to number for accurate comparison
      const numericId = parseInt(selectedWorkOrderId);

      // Check if this ID exists in allWOData
      const woExists = allWOData.some((wo) => wo.woId === numericId);

      if (woExists) {
        setCurrentId(numericId);
      } else {
        console.warn(`Work order ID ${numericId} not found in data`);
      }
    }
  }, [searchParams, allWOData]);

  // Set All Work Orders Data
  useEffect(() => {
    let timeout = setTimeout(() => {
      if (workOrdersList) {
        setAllWOData(workOrdersList);
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [workOrdersList]);

  // get products for selected wo
  useEffect(() => {
    let timeout = setTimeout(() => {
      if (selected?.id && showModal) {
        setIsViewReady(false);
        setSelectedProduct(null);
        setProductsList(null);
        getAllProducts(selected?.id);
      }
    }, 150);
    return () => clearTimeout(timeout);
  }, [selected?.id, showModal]);

  useEffect(() => {
    let timeout = setTimeout(() => {
      if (showModal && productTypesList.length === 0) {
        getAllProductTypes();
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, [showModal, productTypesList]);

  useEffect(() => {
    setPendingProductTypeUpdates({});
  }, [selected?.id]);

  useEffect(() => {
    if (show) {
      setShowModal(show);
    } else {
      setShowModal(false);
      setSelectedProductType(null);
    }
  }, [show]);

  useEffect(() => {
    getReadyStatusForCurrentProductType();
  }, [selectedProductType, productsList, selectedProduct?.isReady]);

  // Set Products List and Selected Product
  useEffect(() => {
    if (!showModal || !allProducts) {
      return;
    }
    setInvoiceReady(selected?.invoiceReady);
    setPrinted(!!selected?.printed);
    if (selectedProductType) {
      const filteredProducts = allProducts?.filter(
        (product) =>
          product?.productTypeId === selectedProductType?.productTypeId,
      );

      if (filteredProducts?.length > 0) {
        setProductsList(filteredProducts);
        setSelectedProduct((prev) => {
          const match = prev && filteredProducts.find((p) => p.id === prev.id);
          return match || filteredProducts[0];
        });
        setIsViewReady(true);
      } else {
        setSelectedProductType(null);
        setProductsList(allProducts);
        setSelectedProduct((prev) => {
          const match = prev && allProducts.find((p) => p.id === prev.id);
          return match || allProducts[0];
        });
        setIsViewReady(true);
      }
      return;
    }

    if ((selected && allProducts, filterBy)) {
      if (filterBy && filterBy?.productTypes !== "Pending") {
        // If filterBy is set, filter products by productType
        const _productsList = allProducts?.filter(
          (product) => product?.productTypeId === filterBy?.productTypeId,
        );

        if (_productsList?.length === 0) {
          setProductsList(allProducts);
          let _newSelectedProduct = allProducts[0];
          setSelectedProduct(_newSelectedProduct);
          let _newSelectedProductType = productTypesList.find(
            (item) => item.productTypeId === _newSelectedProduct?.productTypeId,
          );
          if (_newSelectedProductType) {
            handleProductTypeFilter(_newSelectedProductType);
          } else {
            handleProductTypeFilter(null);
          }
          setIsViewReady(true);
          return;
        }

        setProductsList(_productsList);

        let _selectedProduct = null;
        if (_productsList && _productsList?.length > 0) {
          _selectedProduct = _productsList[0];
          setSelectedProduct(_selectedProduct);
          setIsViewReady(true);

          let _selectedProductType = productTypesList.find(
            (item) => item?.productTypeId === filterBy?.productTypeId,
          );

          if (_selectedProductType) {
            setSelectedProductType(_selectedProductType);
          }
        }
      }
    }
    if (selected && productTypesList && allProducts && !filterBy) {
      /*   Code to set All as product type
       **************** */
      if (selectedProductType) {
        handleProductTypeFilter(selectedProductType);
      } else {
        handleProductTypeFilter(null);
      }

      /*   below code set's first product type as default selected
       **************** */
      // // if no filterBy is set, set the first product type as selected product type
      // // and set first product as selected product and products of first product type as products list
      // let _productTypesList = productTypesList?.filter((item) => {
      //   const count = allProducts?.filter(
      //     (product) => product.productType === item.productTypes
      //   );
      //   return count.length > 0;
      // });
      // let _selectedProductType =
      //   _productTypesList?.length > 0 ? _productTypesList[0] : null;

      // handleProductTypeFilter(_selectedProductType);
    }
  }, [selected, productTypesList, filterBy, showModal, allProducts]);

  useEffect(() => {
    if (!showModal || !allProducts) {
      return;
    }
    if (selectedProductType) {
      // If selectedProductType is set, filter products by productType
      const _productsList = allProducts?.filter(
        (product) =>
          product?.productTypeId === selectedProductType?.productTypeId,
      );
      // if there are no products left for selectedProductType
      if (!_productsList || _productsList.length === 0) {
        // // if no filterBy is set, set the first product type as selected product type
        // and set first product as selected product and products of first product type as products list
        let _productTypesList = productTypesList?.filter((item) => {
          const count = allProducts?.filter(
            (product) => product?.productTypeId === item?.productTypeId,
          );
          return count.length > 0;
        });
        let _selectedProductType =
          _productTypesList?.length > 0 ? _productTypesList[0] : null;
        handleProductTypeFilter(_selectedProductType);
      } else {
        setSelectedProduct((prev) => {
          const match = prev && _productsList.find((p) => p.id === prev.id);
          return match || _productsList[0];
        });
        setProductsList(_productsList);
        setIsViewReady(true);
      }
    } else {
      if (filterBy && filterBy?.productTypes !== "Pending") {
        return;
      }
      setProductsList(allProducts);
      setSelectedProduct((prev) => {
        const match = prev && allProducts?.find((p) => p.id === prev.id);
        return match || (allProducts && allProducts[0]);
      });
      setIsViewReady(true);
    }
  }, [selectedProductType, allProducts, showModal, filterBy]);

  const approvalStatus = getApprovalStatus(selected);

  return (
    <div>
      {show === undefined && (
        <button
          className={`${btnClasses}`}
          onClick={() => {
            setShowModal(true);
          }}
        >
          {btnText}
        </button>
      )}

      <Modal
        show={showModal}
        size="xl"
        onHide={async () => {
          resetData();
        }}
        contentClassName="bg-transparent"
        style={{
          // margin: "auto",
          zIndex: 100001,
        }}
      >
        <Modal.Body className="bg-light rounded-3 px-3 py-2">
          <>
            {(loading || !isViewReady) && <Spinner />}

            {/* Header Section */}
            <div className="mx- 1 me-2 d-flex justify-content-between">
              <h4 className="d-flex mb-0 flex-column">
                <div className="d-flex">
                  {(user?.permissions?.includes("work_orders_add") ||
                    user?.permissions?.includes("work_orders_update") ||
                    user?.permissions?.includes("work_orders_delete") ||
                    user?.permissions?.includes("work_orders_dataEntry") ||
                    user?.roles === "admin") && (
                    <button
                      className="btn btn-sm btn-success me-2 py-0 px-1 mb-1"
                      onClick={() => {
                        let status = selected?.WOStatus;
                        if (status === "completed") {
                          status = "all";
                        }
                        const ids =
                          (workOrdersList &&
                            workOrdersList.map((w) => w?.woId)) ||
                          (allWOData && allWOData.map((w) => w?.woId)) ||
                          [];
                        navigate(
                          `/work-order/details/${status}/${selected?.woId}?page=1`,
                          { state: { workOrderIds: ids } },
                        );
                      }}
                    >
                      View
                    </button>
                  )}

                  <h4
                    onDoubleClick={() => {
                      setShowContactModal(true);
                    }}
                    className="d-flex align-items-center my-0 gap-1"
                  >
                    <div>W-{selected?.woId}</div>
                    <div>
                      {selected?.jobName?.length <= 35
                        ? selected?.jobName
                        : `${selected?.jobName?.slice(0, 35)}..`}
                    </div>
                  </h4>
                </div>
                <div className="d-flex align-items-center gap-1 my-0">
                  {(user?.permissions?.includes("work_orders_add") ||
                    user?.permissions?.includes("work_orders_update") ||
                    user?.permissions?.includes("work_orders_delete") ||
                    user?.roles === "admin") &&
                    !hideCustomerViewBtn && (
                      <>
                        <button
                          onClick={handleViewCustomer}
                          className="btn btn-sm btn-info me-0 py-0 px-1 mb-1 "
                        >
                          View
                        </button>
                      </>
                    )}

                  <h4
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    C-{selected?.customer?.customerId} -{" "}
                    {selected?.customerName.length <= 35
                      ? selected?.customerName
                      : `${selected?.customerName.slice(0, 35)}..`}
                    {insideSalesShort}
                  </h4>
                </div>
              </h4>
              <div className="d-flex justify-content-end align-items-center flex-grow-1 ">
                <h5 className="me-1">WO Status</h5>
                <div className="me-1 ">
                  {user?.roles === "customer" ? (
                    <WoStatusReadOnly value={selected?.WOStatus} />
                  ) : (
                    <select
                      value={selected?.WOStatus}
                      onChange={handleWOStatusChange}
                      className="form-select"
                    >
                      {/* Settings -> WO Statuses (2026-10-29) */}
                      <WoStatusOptions current={selected?.WOStatus} />
                    </select>
                  )}
                </div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="no-icon px-1"
                    variant="primary"
                    id="dropdown-basic"
                  >
                    <i className="mdi mdi-dots-vertical "></i>
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="w-25">
                    <Dropdown.Item as="div" className="p-0 m-0">
                      {allWOData && selected && (
                        <WOPdfButton
                          filterBy={selectedProductType?.productTypes}
                          btnTitle={"Print Pdf"}
                          btnClasses={"btn w-100"}
                          btnColor={"text-start btn"}
                          selectedWO={selected}
                          woProducts={allProducts}
                          onPrinted={markPrintedFromPdf}
                        />
                      )}
                    </Dropdown.Item>

                    {selected && (
                      <Dropdown.Item
                        as="div"
                        className="p-0 m-0"
                        // onClick={(e) => {
                        //   e.stopPropagation();
                        // }}
                      >
                        {/* <WOOrderEmail
                          btnClass={"btn w-100"}
                          btnColor={"text-start btn"}
                          btnTitle={"Email"}
                          selectedWorkOrder={selected}
                          wOProductsData={allProducts}
                        /> */}
                        <SendWoApproval
                          woId={selected.woId}
                          // selectedWO={item?.WorkOrder}
                          // woProducts={item?.WorkOrder?.WOProducts}
                          // approvalData={item}
                          refreshFunc={() => {}}
                          btnClass={"btn w-100 text-start"}
                          btnTitle={"Send Approval"}
                          customerApproved={
                            !!selected?.woLotApproval?.allApproved
                          }
                        />
                      </Dropdown.Item>
                    )}
                    {/* Ready to Pickup email (user, 2026-10-27). */}
                    {selected && (
                      <Dropdown.Item as="div" className="p-0 m-0">
                        <SendWoFeedback
                          variant="ready-pickup"
                          woId={selected.woId}
                          refreshFunc={() => {}}
                          btnClass={"btn w-100 text-start"}
                          btnTitle={"Ready to Pickup"}
                        />
                      </Dropdown.Item>
                    )}
                    <Dropdown.Item as="div" className="p-0 m-0">
                      {allWOData && selected && (
                        <WoCuttingPdfButton
                          filterBy={selectedProductType?.productTypes}
                          btnClasses={"btn w-100"}
                          btnColor={"text-start btn"}
                          selectedWO={selected}
                          woProducts={allProducts}
                          onPrinted={markPrintedFromPdf}
                        />
                      )}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                <div className="d-flex gap-1 ms-1">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      previousWorkOrder();
                    }}
                    disabled={allWOData?.length === 0 && loading}
                    className={"btn btn-success btn-sm p-0 px-1 "}
                  >
                    <i className="mdi mdi-arrow-left-bold fs-3 py-0 my-0"></i>
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      nextWorkOrder();
                    }}
                    disabled={allWOData?.length === 0 && loading}
                    className={"btn btn-success btn-sm p-0  px-1"}
                  >
                    <i className="mdi mdi-arrow-right-bold fs-3 py-0 my-0"></i>
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={async () => {
                      resetData();
                    }}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
            <hr className="mt-1 mb-2" />

            {/* List of Filters buttons for product by productType */}
            <div className="my-1 d-flex justify-content-between align-items-center">
              <div className="d-flex gap-1 flex-wrap rounded-3 w-75">
                <button
                  onClick={() => {
                    applyPendingTypeUpdates();
                  }}
                  disabled={getPendingTypeUpdatesCount() === 0 || loading}
                  className="btn btn-sm btn-success"
                >
                  <i className="ri-refresh-line"></i>
                </button>
                <button
                  onClick={() => {
                    setSelectedProductType(null);
                    setProductsList(allProducts);
                    setSelectedProduct(allProducts && allProducts[0]);
                  }}
                  onDoubleClick={() => {
                    handleAllProductSummary();
                  }}
                  className={`btn btn-sm ${
                    !selectedProductType ? "btn-primary" : "btn-outline-primary"
                  }`}
                >
                  All ({allProducts?.length}) - {getTotalQuantity()}
                </button>

                {productTypesList &&
                  selectedProduct &&
                  productTypesList?.map((item) => {
                    if (
                      countProducts(item) &&
                      countProducts(item)["count"] !== 0
                    ) {
                      return (
                        <button
                          key={item.id}
                          onClick={() => {
                            handleProductTypeFilter(item);
                          }}
                          onDoubleClick={() => {
                            handleProductSummary(item);
                          }}
                          className={`btn btn-sm text-nowrap ${
                            selectedProductType?.id === item.id
                              ? "btn-primary"
                              : "btn-outline-primary"
                          }`}
                        >
                          {item?.productTypes} (
                          {countProducts(item) &&
                            `${countProducts(item)["count"]} - ${
                              countProducts(item)["totalQuantity"]
                            }`}
                          )
                        </button>
                      );
                    }
                  })}
              </div>
              <div className="d-flex align-items-start w-25 justify-content-end">
                {/* <div className="me-2 h5 my-0 d-flex flex-column align-items-center justify-content-center">
                  <span>{formatSqlDate({ sqlDate: selected?.WoDueDate })}</span>
                  <span className="mb-1">
                    <span
                      className={
                        !selected?.woLotApproval?.approvalLink
                          ? "badge bg-secondary px-2 py-1"
                          : selected?.woLotApproval?.approvalStatus
                            ? "badge bg-success px-2 py-1"
                            : "badge bg-warning px-2 text-dark py-1"
                      }
                    >
                      {!selected?.woLotApproval?.approvalLink
                        ? "Not Sent"
                        : selected?.woLotApproval?.approvalStatus
                          ? "APPROVED"
                          : "PENDING"}
                    </span>
                  </span>
                </div> */}
                <div className="d-flex align-items-center gap-2">
                  <span
                    className={`btn btn-sm  ${approvalStatus.className}`}
                    style={approvalStatus.style}
                  >
                    {approvalStatus.text}
                  </span>
                  {selected?.woLotApproval?.approvalLink && (
                    <Link
                      to={`/work-order/approvals/${selected?.companyId}/${selected?.woLotApproval?.approvalLink}?viewOnly=true`}
                      className="btn btn-sm btn-primary me-2 flex-center"
                      target="_blank"
                    >
                      A
                    </Link>
                  )}
                </div>
              </div>
            </div>

            {/*   Cards: two independent columns
                 left  = product info 50% / image 50%
                 right = sizes 70% / notes 30%
                 They are separate columns rather than two rows because a row
                 stretches every card on its line to the tallest one, which tied
                 the left cards' height to the right ones and left dead space
                 wherever the two disagreed.
             ********************************************* */}
            <style>
              {`
                .qv-pane { display: flex; flex-direction: column; min-height: 0; }
                .qv-notes .quill { display: flex; flex-direction: column; height: 100%; }
                .qv-notes .ql-container { flex: 1 1 auto; min-height: 0; overflow-y: auto; }
                @media (min-width: 768px) {
                  .qv-cards { height: 660px; }
                  .qv-cards > .qv-col { height: 100%; }
                  .qv-flags { flex: 0 0 auto; }
                  .qv-products, .qv-image { flex: 1 1 50%; }
                  .qv-sizes { flex: 7 1 0; }
                  .qv-notes { flex: 3 1 0; }
                }
              `}
            </style>
            <div className="row qv-cards">
              <div className="col-md-7 px-0 qv-col d-flex flex-column">
                {/* Ready / Invoiced / Printed -- their own card above the
                  product card. Natural height (flex 0 0 auto), so the
                  product and image panes still split the rest 50/50. */}
                <div style={{ padding: "5px 5px" }} className="qv-flags">
                  <div className="bg-white rounded-3 shadow px-3 py-1 d-flex justify-content-start align-items-center flex-wrap gap-4">
                    {/* Printed first, then Ready, then Invoiced. */}
                    <div>
                      <div className="d-flex align-items-center gap-2">
                        <label className="mb-0">Printed?</label>
                        <div>
                          <input
                            onChange={(e) => {
                              e.stopPropagation();
                              setPrinted(e.target.checked);
                              UpdatePrinted({ printed: e.target.checked });
                            }}
                            checked={printed}
                            type="checkbox"
                            id="woPrinted"
                            data-switch="success"
                          />
                          <label
                            htmlFor="woPrinted"
                            data-on-label="Yes"
                            data-off-label="No"
                          ></label>
                        </div>
                      </div>
                    </div>
                    {isViewReady && selectedProduct && (
                      <div>
                        <div className="d-flex align-items-center gap-2">
                          <label className="mb-0">Ready?</label>
                          <div>
                            <div>
                              <input
                                onChange={(e) => {
                                  e.stopPropagation();
                                  setIsAllReady(e.target.checked);
                                  UpdateProductReady({
                                    id: selectedProduct?.id,
                                    ready: e.target.checked,
                                  });
                                }}
                                disabled={!selectedProductType}
                                checked={isAllReady}
                                type="checkbox"
                                id="switch1"
                                data-switch="success"
                              />
                              <label
                                htmlFor="switch1"
                                data-on-label="Yes"
                                data-off-label="No"
                              ></label>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div>
                      <div className="d-flex align-items-center gap-2">
                        <label className="mb-0">Invoiced?</label>
                        <div>
                          {disabledInvoice ? (
                            <>
                              <div>
                                {invoiceReady ? (
                                  <span className="px-2 py-0 h6 rounded-pill ms-1 text-white bg-success">
                                    Yes
                                  </span>
                                ) : (
                                  <span className="px-2 py-0 h6 rounded-pill ms-1 text-white bg-secondary">
                                    No
                                  </span>
                                )}
                              </div>
                            </>
                          ) : (
                            <>
                              <input
                                onChange={(e) => {
                                  e.stopPropagation();
                                  setInvoiceReady(e.target.checked);
                                  UpdateInvoiceReady({
                                    id: selectedProduct?.id,
                                    invoiceReady: e.target.checked,
                                  });
                                }}
                                // disabled={!selectedProductType}
                                checked={invoiceReady}
                                type="checkbox"
                                id="invoiceReady"
                                data-switch="success"
                              />
                              <label
                                htmlFor="invoiceReady"
                                data-on-label="Yes"
                                data-off-label="No"
                              ></label>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Products Info */}
                <div
                  style={{ padding: "5px 5px" }}
                  className="qv-pane qv-products"
                >
                  <div
                    style={{ paddingBottom: "1.1rem", overflowY: "auto" }}
                    className="bg-white rounded-3 h-100 shadow px-3 pt-2"
                  >
                    {isViewReady &&
                    selected &&
                    selectedProduct &&
                    productsList ? (
                      <QuickViewProducts
                        user={user}
                        selected={selected}
                        selectedProduct={selectedProduct}
                        setSelectedProduct={setSelectedProduct}
                        productsList={productsList}
                        setProductsList={setProductsList}
                        productTypesList={productTypesList}
                        refreshFunc={getAllProducts}
                        allProducts={allProducts}
                        setAllProducts={setAllProducts}
                        allWOData={allWOData}
                        setAllWOData={setAllWOData}
                        pendingProductTypeUpdates={pendingProductTypeUpdates}
                        setPendingProductTypeUpdates={
                          setPendingProductTypeUpdates
                        }
                      />
                    ) : (
                      <div
                        style={{
                          minHeight: 300,
                          minWidth: 300,
                        }}
                        className="h3 flex-center text-muted  text-center my-auto"
                      >
                        No Products
                      </div>
                    )}
                  </div>
                </div>
                {/* Product Image */}
                <div
                  style={{ padding: "5px 5px" }}
                  className="qv-pane qv-image"
                >
                  <div
                    style={{ paddingBottom: "1.1rem" }}
                    className="bg-white h-100 rounded-3 shadow px-3 pt-2"
                  >
                    {isViewReady && !loading ? (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ minHeight: 300 }}
                      >
                        {productsList?.length &&
                        selectedProduct?.productImage ? (
                          <ImgWithSignedUrl
                            styles={{
                              maxWidth: "100%",
                              maxHeight: 280,
                              objectFit: "contain",
                            }}
                            path={selectedProduct?.productImage}
                          />
                        ) : (
                          <div
                            style={{
                              minHeight: 300,
                              minWidth: 300,
                            }}
                            className="h3 flex-center text-muted  text-center my-auto"
                          >
                            NO Image{" "}
                          </div>
                        )}
                      </div>
                    ) : (
                      <Spinner />
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-5 px-0 qv-col d-flex flex-column">
                {/* Sizes Info */}
                <div
                  style={{ padding: "5px 5px" }}
                  className="qv-pane qv-sizes"
                >
                  <div className="h-100">
                    <QuickViewProductSizes selectedProduct={selectedProduct} />
                  </div>
                </div>
                {/* Notes */}
                <div
                  style={{ padding: "5px 5px" }}
                  className="qv-pane qv-notes"
                >
                  <style>
                    {` .qill .ql-editor {
                    background-color: red;
                  }`}
                  </style>
                  <div
                    style={{ paddingBottom: "1.1rem" }}
                    className="bg-white rounded-3 shadow-sm p-1 h-100 d-flex flex-column"
                  >
                    <div className="flex-grow-1" style={{ minHeight: 0 }}>
                      <ReactQuill
                        modules={modules}
                        theme="snow"
                        className="h-100"
                        value={selectedProduct?.notes}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Product Summary Modal */}
            <Modal
              show={productSummaryModal}
              onHide={() => {
                setProductSummaryModal(false);
                setProductTypeSummary([]);
              }}
              style={{
                zIndex: 1000105,
              }}
              contentClassName="custom-shadow-sm custom-border-radius px-2"
              size="lg"
            >
              {productTypesList && (
                <QuickViewProductSummary
                  productsList={productsList}
                  productTypeSummary={productTypeSummary}
                  selected={selected}
                  allProducts={allProducts}
                  setAllProducts={setAllProducts}
                  setProductsList={setProductsList}
                  setSelectedProduct={setSelectedProduct}
                  setIsAllReady={setIsAllReady}
                  loading={loading}
                  loadingOn={loadingOn}
                  loadingOff={loadingOff}
                  refreshFunc={handleProductSummary}
                  productTypesList={productTypesList}
                  selectedProductType={selectedProductType}
                  setSelectedProductType={setSelectedProductType}
                  setProductTypeSummary={setProductTypeSummary}
                />
              )}
              <Modal.Footer>
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setProductSummaryModal(false);
                    setProductTypeSummary([]);
                  }}
                >
                  Close
                </button>
              </Modal.Footer>
            </Modal>
            {/* Contact Info Modal */}
            <Modal
              show={showContactModal}
              onHide={() => {
                setShowContactModal(false);
              }}
              contentClassName="custom-shadow-sm custom-border-radius px-2"
              size="lg"
              style={{
                zIndex: 1000105,
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Contact Information</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {/* Add contact information content here */}
                <QuickViewContact
                  selected={selected}
                  showModal={showContactModal}
                  setShowModal={setShowContactModal}
                />
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowContactModal(false)}
                >
                  Close
                </button>
              </Modal.Footer>
            </Modal>
          </>
        </Modal.Body>
      </Modal>
    </div>
  );
}
